import { render } from "./Dashboard.vue?vue&type=template&id=25447e05&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=25447e05&scoped=true&lang=css"

import exportComponent from "/Users/patrykslak/Documents/lauron-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25447e05"]])

export default __exports__